var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isLoading)?_vm._t("default"):_vm._e(),_c('iframe',_vm._b({ref:"content",class:{ 'opacity-0': !_vm.embedLoaded },attrs:{"width":_vm.width},on:{"load":_vm.onLoadIFrame}},'iframe',_vm.attrs,false))],2)}
var staticRenderFns = []

export { render, staticRenderFns }